export default __webpack_public_path__ + "static/media/indicator.96fe32b8.svg";